import { BaseModel } from '../../_base/crud';

export class Permission extends BaseModel {
  scope: string;
}
